import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as runReducer from "containers/Run/reducer";
import * as setupReducer from "containers/Setup/reducer";
import { getStep } from "containers/CreateWizard/reducer";

import ChooseProcessLimitFrontier from "components/CreateWizard/Constraints/ChooseProcessLimitFrontier";

class ChoooseProcessLimitFrontierContainer extends React.PureComponent {
  render() {
    const { step, index } = this.props;

    return <ChooseProcessLimitFrontier {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateProcessLimit: (processLimit) => dispatch(setupReducer.updateProcessLimit(ownProps.id, processLimit, true)),
  updateTimePeriod: (timePeriod) => dispatch(setupReducer.updateTimePeriod(ownProps.id, timePeriod))
});

const mapStateToProps = (state, ownProps) => ({
  total: setupReducer.getTotal(state, ownProps.id),
  trueAction: setupReducer.getTrueAction(state, ownProps.id),
  processLimit: setupReducer.getProcessLimit(state, ownProps.id),
  processLimitPct: setupReducer.getProcessLimitPct(state, ownProps.id),
  processTotal: setupReducer.getTruePositive(state, ownProps.id) + setupReducer.getFalsePositive(state, ownProps.id),
  targeted: setupReducer.getTargeted(state, ownProps.id),
  timePeriod: setupReducer.getTimePeriod(state, ownProps.id),
  defaultProcessLimit: setupReducer.getDefaultProcessLimit(state, ownProps.id),

  winningModel: runReducer.getFirstModel(state, ownProps.id),

  frontier: runReducer.getSortedCapacityModels(state, ownProps.id),

  step: getStep(state)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(ChoooseProcessLimitFrontierContainer);
